const buildSuccess = (_message, _data = null) => {
  return {
    status: 'success',
    message: _message,
    data: _data,
  };
};

const buildFailure = (_message, _data = null) => {
  return {
    status: 'failure',
    message: _message,
    data: _data,
  };
};

const ResponseService = {
  buildSuccess,
  buildFailure,
};

export default ResponseService;
